(() => {
  const KEY = 'cotsocoWishlist';

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  };

  const saveWishlist = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent('cotsoco:wishlist-change', {
        detail: { items }
      })
    );
  };
const updateCount = () => {
  const wishlist = getWishlist();

  document.querySelectorAll('[data-cv-wishlist-count]').forEach((count) => {
    count.textContent = wishlist.length;
    count.hidden = wishlist.length === 0;
  });
};
const flyToSaved = (button) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const source = button.querySelector('svg');
  const target = document.querySelector('.cv-header-saved');

  if (!source || !target) return;

  const start = source.getBoundingClientRect();
  const end = target.getBoundingClientRect();

  const flyer = source.cloneNode(true);
  flyer.classList.add('cv-wishlist-flyer');

  flyer.style.left = `${start.left + start.width / 2 - 11}px`;
  flyer.style.top = `${start.top + start.height / 2 - 11}px`;

  document.body.appendChild(flyer);

  const dx =
    end.left + end.width / 2 -
    (start.left + start.width / 2);

  const dy =
    end.top + end.height / 2 -
    (start.top + start.height / 2);

  requestAnimationFrame(() => {
    flyer.style.transform = `translate(${dx}px, ${dy}px) scale(.55)`;
    flyer.style.opacity = '0.15';
  });

  setTimeout(() => {
    flyer.remove();

    const count = target.querySelector('[data-cv-wishlist-count]');

    if (count) {
      count.classList.remove('cv-count-bump');

      requestAnimationFrame(() => {
        count.classList.add('cv-count-bump');
      });

      setTimeout(() => {
        count.classList.remove('cv-count-bump');
      }, 420);
    }
  }, 560);
};
  const updateButtons = () => {
    const wishlist = getWishlist();

    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const handle = button.dataset.productHandle;
      const saved = wishlist.includes(handle);

      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        saved ? 'Remove from saved products' : 'Save product'
      );
      const label = button.querySelector('.cv-product-wishlist > span');

    if (label) {
      label.textContent = saved
        ? 'Saved to your collection'
        : 'Save to your collection';
    }
    });
    updateCount();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (!handle) return;

    let wishlist = getWishlist();

   if (wishlist.includes(handle)) {
    wishlist = wishlist.filter((item) => item !== handle);
  } else {
    wishlist.push(handle);
    flyToSaved(button);
  }

    saveWishlist(wishlist);
    updateButtons();
  });

  document.addEventListener('DOMContentLoaded', updateButtons);
  document.addEventListener('shopify:section:load', updateButtons);

  window.CotsocoWishlist = {
    get: getWishlist,
    refresh: updateButtons
  };
})();